/**
 * WalkAndPunch API
 * This is the WalkAndPunch API
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ProjectDetailsViewModel } from '../model/projectDetailsViewModel';
import { ProjectViewModel } from '../model/projectViewModel';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ProjectService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param cutoffDate 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public cleanBulkUpdateZipsOnStorageByDateTime(cutoffDate?: Date, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public cleanBulkUpdateZipsOnStorageByDateTime(cutoffDate?: Date, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public cleanBulkUpdateZipsOnStorageByDateTime(cutoffDate?: Date, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public cleanBulkUpdateZipsOnStorageByDateTime(cutoffDate?: Date, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (cutoffDate !== undefined && cutoffDate !== null) {
            queryParameters = queryParameters.set('cutoffDate', <any>cutoffDate.toISOString());
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/v1/Project/CleanBulkUpdateZipsOnStorageByDateTime`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param projectId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public cleanBulkUpdateZipsOnStorageByProject(projectId?: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public cleanBulkUpdateZipsOnStorageByProject(projectId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public cleanBulkUpdateZipsOnStorageByProject(projectId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public cleanBulkUpdateZipsOnStorageByProject(projectId?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (projectId !== undefined && projectId !== null) {
            queryParameters = queryParameters.set('projectId', <any>projectId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/v1/Project/CleanBulkUpdateZipsOnStorageByProject`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param projectId 
     * @param deleteAll 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteProject(projectId?: number, deleteAll?: boolean, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public deleteProject(projectId?: number, deleteAll?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public deleteProject(projectId?: number, deleteAll?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public deleteProject(projectId?: number, deleteAll?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (projectId !== undefined && projectId !== null) {
            queryParameters = queryParameters.set('projectId', <any>projectId);
        }
        if (deleteAll !== undefined && deleteAll !== null) {
            queryParameters = queryParameters.set('deleteAll', <any>deleteAll);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<boolean>('delete',`${this.basePath}/v1/Project`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAllProjects(observe?: 'body', reportProgress?: boolean): Observable<Array<ProjectViewModel>>;
    public getAllProjects(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ProjectViewModel>>>;
    public getAllProjects(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ProjectViewModel>>>;
    public getAllProjects(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ProjectViewModel>>('get',`${this.basePath}/v1/Project/allProjects`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAllProjectsRepository(observe?: 'body', reportProgress?: boolean): Observable<Array<ProjectViewModel>>;
    public getAllProjectsRepository(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ProjectViewModel>>>;
    public getAllProjectsRepository(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ProjectViewModel>>>;
    public getAllProjectsRepository(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ProjectViewModel>>('get',`${this.basePath}/v1/Project/allProjects/repository`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param projectId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getProjectDetails(projectId?: number, observe?: 'body', reportProgress?: boolean): Observable<ProjectDetailsViewModel>;
    public getProjectDetails(projectId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ProjectDetailsViewModel>>;
    public getProjectDetails(projectId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ProjectDetailsViewModel>>;
    public getProjectDetails(projectId?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (projectId !== undefined && projectId !== null) {
            queryParameters = queryParameters.set('projectId', <any>projectId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ProjectDetailsViewModel>('get',`${this.basePath}/v1/Project/details`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getProjectsWithAtLeastOneTemplate(observe?: 'body', reportProgress?: boolean): Observable<Array<ProjectViewModel>>;
    public getProjectsWithAtLeastOneTemplate(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ProjectViewModel>>>;
    public getProjectsWithAtLeastOneTemplate(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ProjectViewModel>>>;
    public getProjectsWithAtLeastOneTemplate(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ProjectViewModel>>('get',`${this.basePath}/v1/Project/allWithAtleastOneTemplate`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param projectId 
     * @param nodeLevel 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public syncProjectElementsProcess(projectId?: number, nodeLevel?: number, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public syncProjectElementsProcess(projectId?: number, nodeLevel?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public syncProjectElementsProcess(projectId?: number, nodeLevel?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public syncProjectElementsProcess(projectId?: number, nodeLevel?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (projectId !== undefined && projectId !== null) {
            queryParameters = queryParameters.set('projectId', <any>projectId);
        }
        if (nodeLevel !== undefined && nodeLevel !== null) {
            queryParameters = queryParameters.set('nodeLevel', <any>nodeLevel);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<number>('post',`${this.basePath}/v1/Project/syncProjectElements/Process`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
